export default "__VITE_ASSET__f080eb25__"